import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { getSoftwareCategories } from '../-query/api';
import { SearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/software/_layout/library/search/')({
  validateSearch: zodValidator(SearchSchema),
  loader: async () => {
    const categories = await getSoftwareCategories();
    return {
      categories
    } as const;
  }
});